<template>
  <div class="mx-2">
    <v-row>
      <v-col md="6">
        <v-row>
          <v-col>
          <v-card shrink>
            <v-toolbar flat color="grey lighten-3">
              <v-toolbar-title>{{ $t('campaigns.label.campaignWelcomeMessages') }}</v-toolbar-title>
            </v-toolbar>
            <CampaignWelcome
              :editionMode="editionMode" 
              :campaign="campaign"
              @change="onChange"
            ></CampaignWelcome>
          </v-card>          
          </v-col>
        </v-row>
        <v-row>
          <v-col>
          <v-card shrink>
            <v-toolbar flat color="grey lighten-3">
              <v-toolbar-title>{{ $t('campaigns.label.sessionStopMessages') }}</v-toolbar-title>
            </v-toolbar>
            <CampaignStop
              :editionMode="editionMode" 
              :campaign="campaign"
              @change="onChange"
            ></CampaignStop>
          </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="6">
        <v-row>
          <v-col>
            <v-card shrink>
              <v-toolbar flat color="grey lighten-3">
                <v-toolbar-title>{{ $t('campaigns.label.sessionOverviewMessages') }}</v-toolbar-title>
              </v-toolbar>
              <CampaignOverview
                :editionMode="editionMode" 
                :campaign="campaign"
                @change="onChange"
              ></CampaignOverview>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CampaignWelcome from "./CampaignWelcome";
import CampaignOverview from "./CampaignOverview";
import CampaignStop from "./CampaignStop";

export default {
  props: [ "campaign", "editionMode"],
  components: {
    CampaignWelcome,
    CampaignOverview,
    CampaignStop,
  },
  methods: {
    onChange(event) {
      this.$emit("change", event)
    }
  }
}
</script>